/* VH Life — 7-day trial, one per customer (2026-09-19).
   Two trial orders were placed by the same buyer in consecutive minutes, because the
   basket-level check only stops a second trial inside ONE order. This hides the trial
   card once this browser has bought it. The flag is set by the Shopify custom pixel
   "VH trial guard", which fires on checkout_completed and writes the vh_trial cookie.
   Not airtight on its own (a new browser or incognito resets it); the durable fix is a
   checkout validation rule. This stops the ordinary repeat, which is what happened. */
(function () {
  "use strict";
  function used() {
    try {
      if (document.cookie.indexOf("vh_trial=1") !== -1) return true;
      if (localStorage.getItem("vh-trial-used") === "1") return true;
    } catch (e) {}
    return false;
  }
  function hide() {
    var cards = document.querySelectorAll("[data-vh-trial-card]");
    if (!cards.length) return;
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var input = card.querySelector("input");
      if (input && input.checked) {
        var first = document.querySelector('[data-im-plan][value="sub"]') ||
                    document.querySelector("[data-im-plan]");
        if (first) { first.checked = true; first.dispatchEvent(new Event("change", { bubbles: true })); }
      }
      card.setAttribute("hidden", "hidden");
      card.style.display = "none";
    }
  }
  function run() { if (used()) hide(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  /* The cart can be re-rendered by section refreshes; re-check after those. */
  document.addEventListener("cart:change", run);
})();
